/** Чтение текущего авторизованного пользователя. */
import { useQuery } from "@tanstack/react-query";
import { Api } from "@/api";
import { hasAccessToken } from "@/shared/store";
import { usersKeys } from "./keys";

export const useCurrentUser = () => {
	const query = useQuery({
		enabled: hasAccessToken(),
		queryFn: Api.User.getApiUsersMe,
		queryKey: usersKeys.me,
	});

	return {
		data: query.data?.data ?? null,
		error: query.data?.error ?? null,
		isPending: query.isPending,
		refetch: query.refetch,
	};
};
